import script from "./PromotionRewardsCard.vue?vue&type=script&setup=true&lang=js"
export * from "./PromotionRewardsCard.vue?vue&type=script&setup=true&lang=js"

import "./PromotionRewardsCard.vue?vue&type=style&index=0&id=164d05ce&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-164d05ce"]])

export default __exports__